export default "/images/vendor/flag-icon-css/flags/1x1/va.svg?cf15a64943f6c7d24a2b93629bd1def5";